import { Helmet } from 'react-helmet-async';
import React from 'react';
import PermissionsFormContainer from '../../../../containers/organizations/PermissionsFormContainer.jsx';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

const NewPermissions = ({ userId, slug }) => (
  <>
    <Helmet>
      <title>Permissions | ChangeSync</title>
    </Helmet>

    <PermissionsFormContainer userId={userId} />
  </>
);

NewPermissions.getInitialProps = ({ query }) => ({
  slug: query.slug,
  userId: Number(query.userId),
});

export default requireAuth(withRouterParams(NewPermissions));
